import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";
import { format, sub } from 'date-fns'
import api from "../../services/api";

const useTickets = ({
  searchParam,
  tags,
  users,
  pageNumber,
  status,
  date,
  dateStart,
  dateEnd,
  updatedAt,
  showAll,
  queueIds,
  withUnreadMessages,
  whatsappIds,
  statusFilter,
  forceSearch,
  userFilter,
  sortTickets,
  searchOnMessages
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [count, setCount] = useState(0);
  const [searchCounts, setSearchCounts] = useState({ totalMatchedMessages: 0, receivedMessagesCount: 0, receivedContactsCount: 0 });

  useEffect(() => {
    setLoading(true);
    let active = true;
    const debounceMs = searchParam ? 250 : 0;
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        if (userFilter === undefined || userFilter === null) {
          try {            
            const { data } = await api.get("/tickets", {
              params: {
                searchParam,
                pageNumber,
                tags,
                users,
                status,
                date,
                dateStart,
                dateEnd,
                updatedAt,
                showAll,
                queueIds,
                withUnreadMessages,
                whatsapps: whatsappIds,
                statusFilter,
                sortTickets,
                searchOnMessages
              },
            });
            
            let tickets = [];
            
            tickets = data.tickets;
          
            if (active) {
              setTickets(tickets);
              setHasMore(data.hasMore);
              setCount(data.count)
              setSearchCounts({
                totalMatchedMessages: Number(data.totalMatchedMessages) || 0,
                receivedMessagesCount: Number(data.receivedMessagesCount) || 0,
                receivedContactsCount: Number(data.receivedContactsCount) || 0,
              });
              setLoading(false);
            }
          } catch (err) {
            if (active) {
              setLoading(false);
              toastError(err);
            }
          }
        } else {
          try {
            // console.log("ENTROU AQUI DASH")
            // console.log(status,
            //   showAll,
            //   queueIds,
            //   format(sub(new Date(), { days: 30 }), 'yyyy-MM-dd'),
            //   format(new Date(), 'yyyy-MM-dd'),
            //   userFilter)

            const {data} = await api.get("/dashboard/moments", {
              params: {
                status,
                showAll,
                queueIds,
                dateStart: format(sub(new Date(), { days: 30 }), 'yyyy-MM-dd'),
                dateEnd: format(new Date(), 'yyyy-MM-dd'),
                userId: userFilter
              }
            })

            // console.log(data)
            let tickets = [];
            tickets = data.filter(item => item.userId == userFilter);            

            if (active) {
              setTickets(tickets);
              setHasMore(null);
              setLoading(false);
            }
          } catch (err) {
            if (active) {
              setLoading(false);
              toastError(err);
            }
          }
        }
      };
    fetchTickets();
    }, debounceMs);
    return () => {
      active = false;
      clearTimeout(delayDebounceFn);
    };
  }, [
    searchParam,
    tags,
    users,
    pageNumber,
    status,
    date,
    dateStart,
    dateEnd,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    whatsappIds,
    statusFilter,
    forceSearch,
    sortTickets,
    searchOnMessages,
    userFilter
  ]);

  return { tickets, loading, hasMore, count, searchCounts };
};

export default useTickets;
